import { __assign } from 'tslib';
import * as React from 'react';
import { classNames } from 'uitk-react-utils';
import styles from '../../../uitk-calendar.css';
import { UitkBarStyle } from '../EventBar/uitk-bar-style.esm.js';
var getClassNameList = classNames.bind(styles);
var UitkLegendSwatches = function (props) {
  var size = props.size,
    barStyle = props.barStyle;
  var wrapperClassNames = getClassNameList('uitk-legend-swatches', "uitk-legend-swatches-size-".concat(size));
  return React.createElement("div", {
    className: wrapperClassNames
  }, React.createElement(UitkBarStyle, __assign({}, barStyle)));
};
UitkLegendSwatches.displayName = 'UitkLegendSwatches';
export { UitkLegendSwatches };